import { useState, useEffect } from "react";

export const useLocalStorage = (key, initialValue) => {
  const [value, setValue] = useState(() => {
    try {
      const stored = localStorage.getItem(key);
      return stored ? JSON.parse(stored) : initialValue;
    } catch {
      return initialValue;
    }
  });

  // ✅ sync to localStorage
  useEffect(() => {
    localStorage.setItem(key, JSON.stringify(value));

    // 🔥 notify same tab
    window.dispatchEvent(
      new CustomEvent("LOCAL_STORAGE_CHANGE", {
        detail: { key, value },
      })
    );
  }, [key, value]);

  // ✅ listen for changes (same tab + other tabs)
  useEffect(() => {
    const handleChange = (e) => {
      if (e.detail?.key === key) {
        setValue(e.detail.value);
      }
    };

    const handleStorage = (e) => {
      if (e.key === key) {
        setValue(e.newValue ? JSON.parse(e.newValue) : null);
      }
    };

    window.addEventListener("LOCAL_STORAGE_CHANGE", handleChange);
    window.addEventListener("storage", handleStorage);

    return () => {
      window.removeEventListener("LOCAL_STORAGE_CHANGE", handleChange);
      window.removeEventListener("storage", handleStorage);
    };
  }, [key]);

  return [value, setValue];
};

// import { useState, useEffect } from "react";

// export const useLocalStorage = (key, initialValue) => {
//   // ✅ lazy init (runs once)
//   const [value, setValue] = useState(() => {
//     try {
//       const stored = localStorage.getItem(key);
//       return stored ? JSON.parse(stored) : initialValue;
//     } catch (e) {
//       console.error("Error reading localStorage", e);
//       return initialValue;
//     }
//   });

//   // ✅ sync to localStorage
//   useEffect(() => {
//     try {
//       localStorage.setItem(key, JSON.stringify(value));
//     } catch (e) {
//       console.error("Error writing localStorage", e);
//     }
//   }, [key, value]);

//   return [value, setValue];
// };